<template>
    <b-row class="headline">
      <b-col class="title">
        {{ title }}
      </b-col>
      <!--<b-col sm="auto" class="d-flex align-items-center" v-if="$slots.default">-->
      <b-col class="d-flex align-items-center justify-content-end pr-0" v-if="$slots.default">
        <slot></slot>
      </b-col>
    </b-row>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .headline {
    margin-bottom: 2em;
    padding: 0 20px;
    border: none !important;
    box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include media-breakpoint-down(sm) {
      margin-bottom: 1em;
      padding: 0 20px 0.4em 20px;
    }

    .title {
      padding: 0.5rem 2rem;
      padding-left: 0;
      font-size: 1.5rem;
      font-family: 'AvenirHeavy';
      @include media-breakpoint-down(sm) {
        font-size: 1.3rem;
        padding: 0;
      }
    }

    /*
    @include media-breakpoint-up(sm) {
      .title {
        text-align: left;
      }
    }
    */
  }
</style>

<script>
export default {
  name: 'Headline',
  props: {
    title: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/Headline.vue